import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "benefit-calculator" }
const _hoisted_2 = { class: "benefit_calculator__address benefit_calculator__blade" }
const _hoisted_3 = { class: "benefit-calculator__field--full" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "benefit-calculator__field--full"
}
const _hoisted_6 = {
  key: 2,
  class: "benefit-calculator__field--full"
}
const _hoisted_7 = {
  key: 3,
  class: "benefit-calculator__field--checkbox"
}
const _hoisted_8 = { key: 4 }
const _hoisted_9 = {
  key: 5,
  class: "benefit-calculator__module-info benefit-calculator__field--full"
}
const _hoisted_10 = { class: "calculator__blade" }
const _hoisted_11 = {
  key: 1,
  class: "benefit-calculator__submit-error"
}

import { computed, reactive, watch } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChartLineUp } from '@fortawesome/pro-solid-svg-icons';
import InputField from '@/components/InputField.vue';
import SelectField from '@/components/SelectField.vue';
import CityInterface from '@/interfaces/CityInterface';
import StreetInterface from '@/interfaces/StreetInterface';
import { OrderAPI } from '@/api';
import BaseButton from '@/components/BaseButton.vue';
import RadioButtons from '@/components/RadioButtons.vue';
import Checkbox from '@/components/Checkbox.vue';
import Benefit from '@/interfaces/BenefitInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'BenefitCalculator',
  props: {
  preselectedOptions: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: () => 'standalone',
    validator: (type: string) => ['standalone', 'component'].indexOf(type) !== -1,
  },
},
  setup(__props) {

library.add(faChartLineUp);

const props = __props;

const postcodeError = reactive({ value: null as string | null });
const cityError = reactive({ value: null as string | null });
const streetError = reactive({ value: null as string | null });
const houseNumberError = reactive({ value: null as string | null });
const usageError = reactive({ value: null as string | null });

const preselectedOptions: Record<string, unknown> = {
  hasControllableDevice: null,
  type: null,
  seperatedMeasurement: null,
  after2024: null,
  hasImsys: null,
  module: null,
  postcode: null,
  city: null,
  street: null,
  houseNumber: null,
  usage: null,
};

Object.keys(preselectedOptions)
  .forEach((key) => {
    if (props.preselectedOptions && props.preselectedOptions[key] !== undefined) {
      if (props.preselectedOptions[key] === 1) {
        preselectedOptions[key] = true;
      } else if ((props.preselectedOptions[key] === null || props.preselectedOptions[key] === 0) && props.type === 'component') {
        preselectedOptions[key] = false;
      } else {
        preselectedOptions[key] = props.preselectedOptions[key];
      }
    }
  });

const options = reactive({
  hasControllableDevice: preselectedOptions.hasControllableDevice as boolean || true,
  type: preselectedOptions.type || null as string | null,
  seperatedMeasurement: preselectedOptions.seperatedMeasurement as boolean,
  after2024: preselectedOptions.after2024 as boolean,
  hasImsys: preselectedOptions.hasImsys as boolean,
  module: preselectedOptions.module || null as string | null,
  postcode: preselectedOptions.postcode as string | null,
  postcodeLoaded: '',
  initialStreet: !!preselectedOptions.street,
  isFetching: false,
  preselectedPostcodeSet: false,
  selectableCities: [] as CityInterface[],
  selectableStreets: [] as StreetInterface[],
  city: preselectedOptions.city || null as string | null,
  street: preselectedOptions.street || null as string | null,
  houseNumber: preselectedOptions.houseNumber as string | null,
  usage: preselectedOptions.usage || null as number | string | null,
  benefitExists: {
    for: null as string | null,
    data: null as Benefit | null,
  },
});

const resetDeviceState = (level: 'device' | 'type' | 'measurement' | 'installation' | 'imsys') => {
  // eslint-disable-next-line default-case
  switch (level) {
    case 'device':
      options.type = null;
      break;
    case 'type':
      options.seperatedMeasurement = null;
      break;
    case 'measurement':
      options.after2024 = null;
      break;
    case 'installation':
      options.hasImsys = false;
      break;
    case 'imsys':
      options.module = null;
  }
};

// --- WATCHERS (REDUCED) ---
watch(() => options.hasControllableDevice, (val) => {
  if (val === false as boolean) resetDeviceState('device');
});

watch(() => options.type, () => resetDeviceState('type'));
watch(() => options.seperatedMeasurement, () => resetDeviceState('measurement'));
watch(() => options.after2024, () => resetDeviceState('installation'));

watch(() => options.hasImsys, (val) => {
  if (!val && options.module === '3') {
    options.module = null;
  }
});

const isHeatPumpWithoutSeparatedMeasurementAfter2024 = computed(() => options.type === 'heatPump'
    && options.seperatedMeasurement === false
    && options.after2024 === true);

watch(isHeatPumpWithoutSeparatedMeasurementAfter2024, (isHeatPump) => {
  if (isHeatPump && options.module !== '1') {
    options.module = null;
  }
});

const showImsys = computed(() => options.after2024 === true && options.type !== 'heatStorage');

const showModule = computed(() => showImsys.value);

const moduleOptions = computed(() => {
  const all = [
    { label: 'Modul 1', value: '1' },
    { label: 'Modul 2', value: '2' },
    { label: 'Modul 1 + 3', value: '3' },
  ];

  if (isHeatPumpWithoutSeparatedMeasurementAfter2024.value) {
    return all.filter((m) => m.value === '1');
  }

  return options.hasImsys ? all : all.filter((m) => m.value !== '3');
});

const showModule3Text = computed(() => options.hasControllableDevice === true
    && (options.type === 'heatPump' || options.type === 'emobility')
    && options.seperatedMeasurement === false
    && options.after2024 === true
    && options.hasImsys === true
    && options.module === '3');

watch(moduleOptions, (newOptions) => {
  if (newOptions.length === 1) {
    options.module = newOptions[0].value;
  }
}, { immediate: true });

// --- TYPE OPTIONS ---
const typeOptions = [
  { label: 'Speicherheizung', value: 'heatStorage' },
  { label: 'Wärmepumpe', value: 'heatPump' },
  { label: 'E-Mobilität', value: 'emobility' },
  { label: 'Wärmepumpe & E-Mobilität', value: 'heatPumpAndEmobility' },
];

const fetchCitiesAndStreets = ($postcode: string | number) => {
  if (`${$postcode}`.length === 5 && $postcode !== options.postcodeLoaded) {
    options.selectableCities = [];
    options.selectableStreets = [];

    options.postcodeLoaded = $postcode as string;
    postcodeError.value = null;

    OrderAPI.getCitiesAndStreets($postcode)
      .then((data) => {
        options.selectableCities = data.cities;
        options.selectableStreets = data.streets;
        if (!(preselectedOptions.postcode === $postcode && !options.preselectedPostcodeSet)) {
          options.city = options.selectableCities[0].city || options.selectableCities[0].id;
          options.street = options.selectableStreets[0].street || options.selectableStreets[0].id;
          options.preselectedPostcodeSet = true;
        }
      }).catch(() => {
        postcodeError.value = 'Ungültige Postleitzahl';
      });
  }
};

watch(() => options.postcode, ($newPostcode) => {
  fetchCitiesAndStreets($newPostcode as string);
});

watch([() => options.city, () => options.street, () => options.houseNumber, () => options.usage], () => {
  cityError.value = null;
  streetError.value = null;
  houseNumberError.value = null;
  usageError.value = null;
});

const getSubmitErrorMessage = () => {
  if (!options.hasControllableDevice || options.seperatedMeasurement !== false) return null;

  const { type, after2024 } = options;

  if (after2024 === false) {
    if (type === 'heatPump') return 'Eine Wärmepumpe mit Inbetriebnahme vor dem 01.01.2024 ohne Nachrüstung und separate Messung erhält keine Vergünstigung.';
    if (type === 'emobility') return 'Ein Ladepunkt mit Inbetriebnahme vor dem 01.01.2024 ohne Nachrüstung und separate Messung erhält keine Vergünstigung.';
  }

  if (type === 'heatStorage' && after2024 !== null) {
    return 'Eine Speicherheizung ohne separate Messung erhält keine Vergünstigung. Nachrüstung nicht möglich';
  }

  return null;
};

const submitError = computed(() => getSubmitErrorMessage());

if (`${options.postcode || ''}`.trim().length === 5) {
  fetchCitiesAndStreets(options.postcode as string);
}

const getCitiesOptions = ($cities: CityInterface[]) => [...$cities].map(($c) => ({
  label: $c.city || $c.name,
  value: $c.city || $c.id,
}));

const streetsOptions = computed(() => [...options.selectableStreets].map(($s) => ({
  label: $s.street || $s.name,
  value: $s.street || $s.id,
})));

const canSubmit = computed(() => {
  const baseValid = (options.postcode || '').length === 5
      && options.city
      && options.street
      && (options.houseNumber || '').trim() !== ''
      && parseInt(`${options.usage || '0'}`, 10) > 0;

  if (!options.hasControllableDevice) return baseValid;

  return (
    baseValid
      && options.type
      && options.seperatedMeasurement !== null
      && options.after2024 !== null
      && (!showImsys.value || options.module)
  );
});

const submit = async () => {
  if (!canSubmit.value) return;

  if (submitError.value) return;

  const path = `${window.ioappConfig.shopUrl}preisvorteil`;

  const params: Record<string, string> = {
    stadt: options.city as string,
    strasse: options.street as string,
    hausnummer: options.houseNumber as string,
  };

  if (options.hasControllableDevice) {
    params.controllableDevice = '1';
    params.type = options.type as string;

    if (options.seperatedMeasurement) {
      params.meter = '1';
    }

    if (options.after2024) {
      params.installation = '1';
    }
  }

  if (options.hasImsys) {
    params.smart = '1';
  }

  const urlParams = new URLSearchParams(params);

  if (props.type === 'component') {
    window.location.href = `${path}/${options.postcode}/${options.usage}/${options.module}/?${urlParams.toString()}`;
  } else {
    window.open(
      `${path}/${options.postcode}/${options.usage}/${options.module}/?${urlParams.toString()}`,
      '_blank',
      'noopener,noreferrer',
    );
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["benefit_title", { component: __props.type === 'component' }])
      }, [
        (__props.type === 'standalone')
          ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
              key: 0,
              icon: "fa-solid fa-chart-line-up"
            }))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(__props.type === 'standalone' ? 'Ihr Preisvorteil §14a EnWG' : 'Ihre Angaben'), 1)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RadioButtons, {
          modelValue: options.hasControllableDevice,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((options.hasControllableDevice) = $event)),
          "is-required": ""
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode(" Besitzen Sie eine steuerbare Verbrauchseinrichtung?* ", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (options.hasControllableDevice === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(SelectField, {
              label: "Ihre Verbrauchseinrichtung*",
              modelValue: options.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options.type) = $event)),
              options: typeOptions,
              "is-required": ""
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (options.type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(RadioButtons, {
              modelValue: options.seperatedMeasurement,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((options.seperatedMeasurement) = $event)),
              "is-required": ""
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" Besitzt die steuerbare Verbrauchseinrichtung eine separate Messung?* ", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (options.seperatedMeasurement !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(RadioButtons, {
              modelValue: options.after2024,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((options.after2024) = $event)),
              "is-required": ""
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Fand die Inbetriebnahme oder eine Nachrüstung der Steuerbox nach dem 01.01.2024 statt?* ", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (showImsys.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(Checkbox, {
              modelValue: options.hasImsys,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((options.hasImsys) = $event))
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" Intelligentes Messsystem vorhanden ", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (showModule.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(SelectField, {
              label: "Ihr Modul*",
              modelValue: options.module,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((options.module) = $event)),
              options: moduleOptions.value,
              "is-required": ""
            }, null, 8, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true),
      (showModule3Text.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Der Rabatt des Arbeitspreises der Netznutzung ist abhängig von Ihrem Verbrauchsverhalten in den von Ihrem Netzbetreiber veröffentlichten Zeitfenstern. Die Vergünstigungen durch das Modul 3 erhalten Sie aktuell nur mit dem Tarif ÖKO FLEX STROM im SWSee Netzgebiet. "))
        : _createCommentVNode("", true),
      (!submitError.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
            _createElementVNode("div", null, [
              _createVNode(InputField, {
                label: "Ihre Postleitzahl*",
                "only-numeric": true,
                "error-numeric": "Ungültige Postleitzahl",
                "max-length": 5,
                "min-length": 5,
                "is-required": "",
                modelValue: options.postcode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((options.postcode) = $event)),
                error: postcodeError.value
              }, null, 8, ["modelValue", "error"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(SelectField, {
                label: "Ihre Stadt*",
                modelValue: options.city,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((options.city) = $event)),
                class: _normalizeClass({ 'disabledLabel': `${options.postcode}`.length !== 5 }),
                disabled: options.selectableCities.length <=  1,
                options: getCitiesOptions(options.selectableCities),
                "border-right": false,
                "is-required": "",
                error: cityError.value
              }, null, 8, ["modelValue", "class", "disabled", "options", "error"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(SelectField, {
                label: "Ihre Straße*",
                modelValue: options.street,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((options.street) = $event)),
                class: _normalizeClass({ 'disabledLabel': `${options.postcode}`.length !== 5 && !streetsOptions.value.length}),
                options: streetsOptions.value,
                search: true,
                "is-required": "",
                error: streetError.value
              }, null, 8, ["modelValue", "class", "options", "error"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(InputField, {
                label: "Ihre Hausnummer*",
                type: "text",
                modelValue: options.houseNumber,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((options.houseNumber) = $event)),
                "is-required": "",
                error: houseNumberError.value
              }, null, 8, ["modelValue", "error"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(InputField, {
          label: "Ihr Verbrauch*",
          modelValue: options.usage,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((options.usage) = $event)),
          "only-numeric": "",
          "is-required": "",
          error: usageError.value
        }, null, 8, ["modelValue", "error"])
      ], 512), [
        [_vShow, !submitError.value]
      ]),
      _createElementVNode("div", _hoisted_10, [
        (!submitError.value)
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 0,
              disabled: !canSubmit.value,
              width: "full",
              onClick: _withModifiers(submit, ["prevent"])
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode(" Preisvorteil berechnen ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "benefit-calculator__submit-error-icon" }, "ⓘ", -1)),
              _createTextVNode(" " + _toDisplayString(submitError.value), 1)
            ]))
      ])
    ])
  ]))
}
}

})